// en.js
export default {
    route: {
        success: "success",
        languageSwitched: "Switching successful！",
        niuhui: "NIUHUI",
        about: "About Us",
        about_jj: "Elegance",
        about_story: "Story",
        about_fc: "Elegant Demeanour",
        productList: "Product",
        joinMe: "Join Us",
        values_1: "Integrity",
        values_2: "Collaboration",
        values_3: "Innovation",
        values_4: "Enterprising",
        employees: "Employees",
        brands: "Brands",
        serveCountry: "Serve Country",
        patents: "Patents",
        developmentHistory: "Development History",
        product: "Product",
        niuhuiStoryT: "NIUHUI Story",
        niuhuiStoryC: "NIUHUI people's own firsthand experience",
        productListP: "Please enter the product name, SKU, or category",
        briefIntroduction_1: "Guangzhou Newhui Supply Chain Co., Ltd. was founded in 2013, and the team's founders are all post-85s. They have worked for many internationally renowned companies such as Tencent and Evergrande; After years of hard work and dedication to entrepreneurship, the core personnel have focused on the e-commerce industry, deeply cultivated for many years, and kept up with the times.",
        briefIntroduction_2: "Newhui has been established for nearly ten years, with a team of over a hundred people. Despite facing numerous obstacles during its development, it has remained united and gradually grown stronger,\n" +
            "At present, we are rooted in the cross-border e-commerce industry, with sales channels covering multiple developed countries such as Europe, North America, and Japan. At the same time, we are also exploring various emerging cross-border e-commerce platforms, and our various brand products, mainly luggage and bag products, have already made great strides towards the world. At the same time, the company has gradually established strategic goals for further development and growth:",
        briefIntroduction_3: "Our mission is to create practical beauty in life",
        briefIntroduction_4: "Our vision is to become a globally renowned luggage brand",
        briefIntroduction_5: "Our core values are integrity, cooperation, innovation, and enterprising",
        briefIntroduction_6: "In the process of gradually improving the company's entire industry chain system of research and development, production, and sales, we are also constantly shaping new brand value,\n" +
            "Building brand image, striving to take core brand luggage as the starting point, and spreading the \"practical beauty\" from China's intelligent manufacturing to every corner of the world.",
        briefIntroduction_7: "Newhui always believes in the principle of \"putting people first and dreaming with the country\", and is willing to work hand in hand with you to soar the globe!",
    }
}
